import { render, staticRenderFns } from "./lkuItemSaldoLazzy.vue?vue&type=template&id=333d24a6"
import script from "./lkuItemSaldoLazzy.vue?vue&type=script&lang=js"
export * from "./lkuItemSaldoLazzy.vue?vue&type=script&lang=js"
import style0 from "./lkuItemSaldoLazzy.vue?vue&type=style&index=0&id=333d24a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports